import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BookingProductStepService } from '../services/booking-product-step.service';
import { NavigationService } from '../services/navigation.services';

@Injectable()
export class BookingProductOrderGuard implements CanActivate {

  constructor(
    private bookingProductStepService: BookingProductStepService,
    private router: Router,
    private navigationService: NavigationService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.bookingProductStepService.isBookingOrderAvailable && this.navigationService.existProducts) {
      return true;
    }

    this.router.navigate(['']);

    return false;
  }
}
